import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface AgGridActionButtonConfig {
    iconClass: string;
    onClick: (params: AgGridActionCellRendererParams) => void | Promise<void>;
    isShown: (params?: AgGridActionCellRendererParams) => boolean;
    buttonClass?: string;
    helpContentId?: string;
    disabled?: (params?: AgGridActionCellRendererParams) => boolean;
}

export interface AgGridActionCellRendererParams extends ICellRendererParams {
    buttonConfigs: AgGridActionButtonConfig[];
}

@Component({
    selector: 'grid-action-cell',
    template: `@for (button of params.buttonConfigs; track button) {
        @if (button && button.isShown(params)) {
            <button
                type="button"
                class="ace-btn grid-action-button has-icon"
                [ngClass]="button.buttonClass ? button.buttonClass : 'btn-primary'"
                (click)="button.onClick(params)"
                helpTooltip
                [helpContentId]="button.helpContentId"
                position="bottom"
                [disabled]="button.disabled ? button.disabled(params) : false"
            >
                <i class="fa" [ngClass]="button.iconClass"></i>
            </button>
        }
    } `,
    standalone: false,
})
export class AgGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: AgGridActionCellRendererParams;

    agInit(params: AgGridActionCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
